import React from 'react';
import _ from 'lodash';
import {inject, observer} from 'mobx-react';
import StatusIndicator from './status-indicator';
import AccountHeader from './account-header';
import BandForm from './band-form';
import Bio from '../bio/bio';
import StripeConnect from '../stripe-connect';
import { Modal } from 'client/shared/components';
import autobind from 'autobind-decorator';

import { getNextIncompleteStep, isProfileSetupComplete } from 'client/artist-ui/utils/next-setup-step';

@inject('apiStore', 'artistStore', 'userStore')
@observer
class Account extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            existingAccount: null,
            isConnectingStripe: false,
            showStripeConnectReturnModal: false,
            stripeConnectReturnStatus: null
        };
    }

    componentDidMount () {
        this.checkStripeConnectReturn();
        this.checkConnectAccount();
    }

	render() {
        const { artist, userID, artistStore, rowUserID, userStore } = this.props;

        if (userStore.isLoading || artistStore.isLoading || _.isEmpty(artist)) {

			return (<h3>Account Loading...</h3>);
		}


		const fromLogin = _.isFunction(userStore.getLoggedInUser);
		const user = fromLogin ? userStore.getLoggedInUser() : userStore.getByUserID(rowUserID._id);
        const setupIncomplete = !isProfileSetupComplete(artist.searchStatus);
        const stripeEmphasized =
			getNextIncompleteStep(artist.searchStatus)?.key === 'hasStripeSetup';
        const stripeConnectComplete = this.state.stripeConnectReturnStatus === 'complete';

        return (
            <div className={ `acms-account-page${ setupIncomplete ? ' acms-account-page--setup-incomplete' : '' }` }>
                 <div className="grid-x">
                    <div className="cell auto">
                        <StatusIndicator/>
                    </div>
                </div>
                <div className="grid-x margin-top-1 margin-bottom-1">
                    <div className="cell auto">
                        <AccountHeader artist={ artist } user={ user } />
                    </div>
                </div>
                <div className="grid-x margin-top-3">
                    <div className="cell auto">
                        <BandForm user={ user } artist={ artist } />
                    </div>
                </div>
                <div className="grid-x margin-top-3">
                    <Bio artist={artist} userID={_.isEmpty(userID) ? rowUserID : userID}/>
                </div>
                <div className="grid-x margin-top-3" id="section-stripe">
                    <StripeConnect
						setupConnectAccount={ this.setupConnectAccount }
						existingAccount={ this.state.existingAccount }
						emphasize={ stripeEmphasized }
                        isConnecting={ this.state.isConnectingStripe }
					/>
                </div>
                <Modal
                    isOpen={ this.state.showStripeConnectReturnModal }
                    onClose={ this.closeStripeConnectReturnModal }
                    size="sm"
                    title={ stripeConnectComplete ? 'Stripe connected' : 'Stripe setup paused' }
                    dataTa="stripe-connect-return-modal"
                    footer={
                        <button
                            type="button"
                            className="button"
                            onClick={ this.closeStripeConnectReturnModal }
                            data-ta="stripe-connect-return-modal-close"
                        >
                            Got it
                        </button>
                    }
                >
                    { stripeConnectComplete ? (
                        <p>
                            We received your Stripe update and your payout connection is ready for Muzado.
                        </p>
                    ) : (
                        <p>
                            Your Stripe setup session needs to be restarted. Continue to Stripe again when you are ready.
                        </p>
                    ) }
                </Modal>
            </div>
        );
    }

    @autobind
    async tryConnectAccount () {
        const { artist, artistStore } = this.props;
        if ((artist.paymentServiceID || '').length > 0) {
            return artist.paymentServiceID;
        }

        const res = await artistStore.createConnectAccount(artist.id);
        artist.paymentServiceID = res.data.id;
        this.setState({ existingAccount: res.data });
        return res.data.id;
    }

    @autobind
    async setupConnectAccount () {
        const { artist, artistStore } = this.props;
        this.setState({ isConnectingStripe: true });

        try {
            const accID = await this.tryConnectAccount();
            const accountLink = await artistStore.createAccountLink(accID, artist.id);
            window.location.assign(accountLink.data.url);
        } catch (error) {
            console.error('[setupConnectAccount]', error);
            this.setState({ isConnectingStripe: false });
        }
    }

    @autobind
    async checkConnectAccount () {
        const { artist, artistStore } = this.props;
        if (artist) {
            if ((artist.paymentServiceID || '').length > 0) {
                const res = await artistStore.retrieveConnectAccount(artist.paymentServiceID);
                console.log(res.data);
                this.setState({existingAccount: res.data});
            }
        }
    }

    @autobind
    checkStripeConnectReturn () {
        if (typeof window === 'undefined') {
            return;
        }

        const searchParams = new URLSearchParams(window.location.search);
        const hashSearch = window.location.hash.includes('?')
            ? window.location.hash.split('?')[1]
            : '';
        const hashParams = new URLSearchParams(hashSearch);
        const stripeConnectStatus = searchParams.get('stripe_connect') || hashParams.get('stripe_connect');

        if (stripeConnectStatus === 'complete' || stripeConnectStatus === 'refresh') {
            this.setState({
                showStripeConnectReturnModal: true,
                stripeConnectReturnStatus: stripeConnectStatus
            });
            const cleanURL = `${window.location.origin}${window.location.pathname}${window.location.hash.split('?')[0] || ''}`;
            window.history.replaceState({}, document.title, cleanURL);
        }
    }

    @autobind
    closeStripeConnectReturnModal () {
        this.setState({
            showStripeConnectReturnModal: false,
            stripeConnectReturnStatus: null
        });
    }
}

export default Account;
